import {
  Button,
  IconButton,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
} from '@material-ui/core'
import ReplayIcon from '@material-ui/icons/Replay'
import {
  fetchHRVSummaryReportApi,
  FetchIndividualSummaryReportRequest,
  HRVSummaryResponseWithClient,
  fetchHRVSummaryAnalysisApi,
  HRVSummaryAnalysisResponse,
  createHrvSummaryPDFReport,
} from 'api/analysisApi'
import CardWithTitle from 'components/atoms/CardWithTitle'
import CustomerInfo from 'components/molcules/N1SummaryReport/CustomerInfo'
import CustomerInfoAPI from 'components/molcules/N1SummaryReport/CustomerInfoAPI'
import Logo from 'pages/HealthCenter/Report/Elements/logo.svg'
import HealthCenterReportStyle from 'pages/HealthCenter/Report/Style'
import HRVSummaryN1 from 'components/molcules/N1SummaryReport/HRV/HRVSummary'
import HRVSummaryN1API from 'components/molcules/N1SummaryReport/HRV/HRVSummaryAPI'
import HRVSummaryProfit from 'components/molcules/ProfitSummaryReport/HRV/HRVSummary'
import HRVSummaryProfitAPI from 'components/molcules/ProfitSummaryReport/HRV/HRVSummaryAPI'
import React, {Fragment, useEffect, useMemo, useState} from 'react'
import {useAsync} from 'react-async-hook'
import {useTranslation} from 'react-i18next'
import {useRouteMatch} from 'react-router-dom'
import {
  ReportCustomPadding,
  ReportFetcherWrap,
  ReportWrap,
} from 'pages/Analysis/EEGIndividual/Report'
import {Locale} from 'components/atoms/TranslationSelect'
import useLanguageReport from 'hooks/useLanguageReport'
import useLanguage from 'features/languageReport/useLanguage'
import {getAccessToken} from 'api/storageApi'
import {downloadFileFromWsUrl} from 'helpers/fileHelper'
import Header from 'pages/HealthCenter/Report/Elements/Header'
import HeaderMultiLangReport from 'pages/HealthCenter/Report/Elements/HeaderMultiLang'
import IconDownload from 'pages/HealthCenter/Report/Elements/IconDownload.svg'
import {GenderValue, toGenderString} from 'constants/CommonConstant'
import {INIT_HRV_SUMMARY_ANALYSIS_REPORT} from 'pages/Analysis/EEGSummary/constants'

const useStyles = makeStyles(HealthCenterReportStyle)

function Report() {
  const {t, i18n} = useTranslation()
  const {
    params: {id},
  } = useRouteMatch<{id: string}>()
  const [report, setReport] = useState<HRVSummaryResponseWithClient>()
  const [currentLocale, setCurrentLocale] = useState<Locale>('ko')
  const {textHealthAPI} = useLanguage('health')
  const [analysis, setAnalysis] = useState<HRVSummaryAnalysisResponse>(
    INIT_HRV_SUMMARY_ANALYSIS_REPORT,
  )
  const [loading, setLoading] = useState(false)

  const asyncResult = useAsync(
    fetchHRVSummaryReportApi,
    [
      {
        summaryIds: [Number.parseInt(id, 10)],
        summaryLang: i18n.language as LanguageCode,
      },
    ],
    {
      executeOnMount: true,
      executeOnUpdate: false,
    },
  )

  const getHRVSummaryAnalysis = async () => {
    const response = await fetchHRVSummaryAnalysisApi(
      Number.parseInt(id, 10),
      i18n.language as LanguageCode,
    )
    setAnalysis(response)
  }

  const handleChangeLang = async (value: Locale) => {
    // setLanguage(value)
    await i18n.changeLanguage(value)
    setCurrentLocale(value)
  }

  const handleDownloadPDF = async () => {
    try {
      setLoading(true)
      const createResponse = await createHrvSummaryPDFReport(
        [Number.parseInt(id, 10)],
        i18n.language,
      )
      await downloadFileFromWsUrl(createResponse.ws_url, getAccessToken() ?? '')
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const TAB = [{index: 0, name: t('IHRVSummaryReport')}]

  const LANG = [
    {
      label: t('IKoranLang'),
      value: 'ko',
    },
    {
      label: t('IEnglishLang'),
      value: 'en',
    },
    {
      label: t('IJapanesesLang'),
      value: 'ja',
    },
    {
      label: t('ISpanishLang'),
      value: 'es',
    },
    {
      label: t('IRomanianLang'),
      value: 'ro',
    },
    {
      label: t('IThaiLang'),
      value: 'th',
    },
    {
      label: t('IChineseLang'),
      value: 'zh',
    },
  ]

  const titleHeader = useMemo(() => {
    if (textHealthAPI?.header) {
      return textHealthAPI?.header
    }
    return null
  }, [textHealthAPI])

  useEffect(() => {
    if (asyncResult.currentParams !== null) {
      const {summaryIds} = asyncResult.currentParams[0]
      const newParams: [FetchIndividualSummaryReportRequest] = [
        {summaryIds, summaryLang: i18n.language as LanguageCode},
      ]
      asyncResult.execute(...newParams)
    }
    getHRVSummaryAnalysis()
  }, [i18n.language])

  useEffect(() => {
    if (asyncResult.result !== undefined) {
      const [response] = asyncResult.result.list
      if (response !== undefined) setReport(response)
    }
  }, [asyncResult.result])

  const {isLocalLanguage} = useLanguageReport('hrv')

  useLanguageReport('health')

  const classes = useStyles()
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
        }}
      >
        <div className={`${classes.topNav} no-print`} style={{width: '100%'}}>
          <div className={classes.topNavLeft}>
            <div className={classes.logo}>
              <img src={Logo} alt='Logo' />
            </div>
            <div className={classes.tabs}>
              {TAB.map((tab) => (
                <div
                  className={classes.tab}
                  aria-hidden='true'
                  key={tab.index}
                  style={{
                    color: '#00A29C',
                    fontWeight: 'bold',
                  }}
                >
                  {t(tab.name)}
                </div>
              ))}
            </div>
          </div>
          <div className={classes.topNavRight}>
            <div>
              <Select
                value={currentLocale}
                onChange={(e) => handleChangeLang(e.target.value as Locale)}
                className={classes.searchSelect}
                input={<OutlinedInput name='age' id='outlined-age-simple' />}
              >
                {LANG.map((item) => (
                  <MenuItem value={item.value} key={item.value}>
                    {t(item.label)}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <Button disabled={loading} onClick={handleDownloadPDF}>
              <img src={IconDownload} alt='IconDownload' />
            </Button>
          </div>
        </div>
      </div>
      <ReportWrap
        style={{width: '1300px', margin: '0 auto'}}
        id='print-modified-hrv'
      >
        <ReportFetcherWrap style={{width: '100%', flexDirection: 'column'}}>
          {asyncResult.loading && <div>{t('ILoading')}</div>}
          {asyncResult.error && (
            <div
              style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <div>
                {asyncResult.error.message}
                <IconButton onClick={() => {}} size='small'>
                  <ReplayIcon />
                </IconButton>
              </div>
            </div>
          )}
          {report !== undefined &&
            (isLocalLanguage ? (
              <Header
                title={TAB[0].name}
                content=''
                name={t('IGetFullName', {
                  firstName: report.client.clientFirstName ?? '',
                  lastName: report.client.clientLastName ?? '',
                })}
                sex={t(
                  toGenderString(report.client.clientGender as GenderValue),
                )}
                birthday={report.client.clientBirth.replaceAll('-', '.')}
                measurementDate={
                  report.displayMeasurementDateTime ?? report.treatmentAt ?? ''
                }
              />
            ) : (
              <HeaderMultiLangReport
                title={TAB[0].name}
                tabIndex={0}
                content=''
                name={t('IGetFullName', {
                  firstName: report.client.clientFirstName ?? '',
                  lastName: report.client.clientLastName ?? '',
                })}
                sex={t(
                  toGenderString(report.client.clientGender as GenderValue),
                )}
                birthday={report.client.clientBirth}
                measurementDate={
                  report.displayMeasurementDateTime ?? report.treatmentAt ?? ''
                }
                titleHeader={titleHeader}
              />
            ))}
          <div
            style={{
              paddingBottom: 100,
              background: 'white',
              paddingLeft: 57,
              paddingRight: 57,
            }}
          >
            {!asyncResult.loading &&
              report !== undefined &&
              report.reportType === 'P1' &&
              (isLocalLanguage ? (
                <HRVSummaryProfit
                  {...report}
                  clientFirstName={report.client.clientFirstName ?? ''}
                  clientLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  contourImage={analysis.images.contour}
                  histogramImage={analysis.images.histogram}
                  tableImage={analysis.images.table}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  contour={analysis.scores.contour_level}
                  histogram={analysis.scores.histogram_level}
                  phase={analysis.scores.gas_phase_level}
                />
              ) : (
                <HRVSummaryProfitAPI
                  {...report}
                  clientFirstName={report.client.clientFirstName ?? ''}
                  clientLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  contourImage={analysis.images.contour}
                  histogramImage={analysis.images.histogram}
                  tableImage={analysis.images.table}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  contour={analysis.scores.contour_level}
                  histogram={analysis.scores.histogram_level}
                  phase={analysis.scores.gas_phase_level}
                  autoNervousSystemBalance={
                    analysis.scores.auto_nervous_system_balance
                  }
                />
              ))}
            {!asyncResult.loading &&
              report !== undefined &&
              report.reportType === 'P2' &&
              (isLocalLanguage ? (
                <HRVSummaryProfit
                  {...report}
                  clientFirstName={report.client.clientFirstName ?? ''}
                  clientLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  contourImage={analysis.images.contour}
                  histogramImage={analysis.images.histogram}
                  tableImage={analysis.images.table}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  contour={analysis.scores.contour_level}
                  histogram={analysis.scores.histogram_level}
                  phase={analysis.scores.gas_phase_level}
                />
              ) : (
                <HRVSummaryProfitAPI
                  {...report}
                  clientFirstName={report.client.clientFirstName ?? ''}
                  clientLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  contourImage={analysis.images.contour}
                  histogramImage={analysis.images.histogram}
                  tableImage={analysis.images.table}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  contour={analysis.scores.contour_level}
                  histogram={analysis.scores.histogram_level}
                  phase={analysis.scores.gas_phase_level}
                  autoNervousSystemBalance={
                    analysis.scores.auto_nervous_system_balance
                  }
                />
              ))}
            {!asyncResult.loading &&
              report !== undefined &&
              report.reportType === 'N1' &&
              (isLocalLanguage ? (
                <HRVSummaryN1
                  {...report}
                  customerFirstName={report.client.clientFirstName ?? ''}
                  customerLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  phase={analysis.scores.gas_phase_level}
                />
              ) : (
                <HRVSummaryN1API
                  {...report}
                  customerFirstName={report.client.clientFirstName ?? ''}
                  customerLastName={report.client.clientLastName ?? ''}
                  circularImage={analysis.images.circular}
                  depression={analysis.scores.depression_level}
                  anxiety={analysis.scores.anxiety_level}
                  phase={analysis.scores.gas_phase_level}
                  autoNervousSystemBalance={
                    analysis.scores.auto_nervous_system_balance
                  }
                />
              ))}
            {!asyncResult.loading &&
              asyncResult.error === undefined &&
              report === undefined && (
                <div style={{minHeight: 400}}>출력할 결과지가 없습니다.</div>
              )}
          </div>
          <ReportCustomPadding />
        </ReportFetcherWrap>
        <ReportCustomPadding />
      </ReportWrap>
    </Fragment>
  )
}

export default Report
